module.exports = __webpack_public_path__ + "static/media/trekspresso-4.47f6cb03.jpg";